import React from "react";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import autoTable from "jspdf-autotable";
import { Row, Col, Container, Card, CardBody, Form } from "react-bootstrap";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import * as Yup from "yup";
import { Button } from "@mui/material";
import { FaKey } from "react-icons/fa";

export default function ManualChangePswd() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  let username = localStorage.getItem("username");

  const formik = useFormik({
    initialValues: { existingpassword: "", newPassword: "", confirmPassword: "", },
    validationSchema: Yup.object().shape({
      existingpassword: Yup.string().required("Required."),
      newPassword: Yup.string().required("Required.").min(10, "At least 10 characters.").matches(/[a-z]/, "Ateast one lowercase letter.").matches(/[A-Z]/, "Ateast one uppercase letter.").matches(/\d/, "Ateast one number.").matches(/[@$!%*?&#]/, "Ateast one special character."),
      confirmPassword: Yup.string().required("Required.").oneOf([Yup.ref("newPassword"), null], "Passwords must match."),
    }),
    onSubmit: async (values) => {
      const params = { userId: username, existingpassword: values.existingpassword, newPassword: values.newPassword, confirmPassword: values.confirmPassword, };
      try {
        store.dispatch({ type: "SHOW_SPINNER" });
        const res = await KpiService.userchangepassword(params);
        if (res?.data) {
          showAlertMessage(res.data, "success");
          formik.resetForm();
        }
      } catch (error) { console.error("Error changing password:", error); } finally { store.dispatch({ type: "HIDE_SPINNER" }); }
    },
  });

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "60%" }}>
        <div className="sa-title"> <h2> Change<span> Password</span> </h2> </div>
      </Container>
      <Container fluid style={{ width: "60%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Card className="mb-5 rounded-2 border" style={{ borderColor: "#ccc", boxShadow: "none" }}>
              <CardBody>
                <Row className="d-flex justify-content-center">
                  <Col xxl={5} xl={5} lg={5} md={6} sm={12} xs={12} className="mb-4">
                    <Form.Group> <Form.Label> Old Password <span className="text-danger">*</span> </Form.Label> <Field type="password" name="existingpassword" placeholder="old password" className={`form-control w-100 ${formik.touched.existingpassword && formik.errors.existingpassword ? "is-invalid" : ""}`} /> <ErrorMessage name="existingpassword" component="div" className="text-danger mt-2" /> </Form.Group>
                  </Col>
                </Row>
                <Row className="d-flex justify-content-center">
                  <Col xxl={5} xl={5} lg={5} md={6} sm={12} xs={12} className="mb-4">
                    <Form.Group> <Form.Label> New Password<span className="text-danger">*</span> </Form.Label> <Field type="password" name="newPassword" placeholder="new password" className={`form-control w-100 ${formik.touched.newPassword && formik.errors.newPassword ? "is-invalid" : ""}`} /> <ErrorMessage name="newPassword" component="div" className="text-danger mt-2" /> </Form.Group>
                  </Col>
                </Row>

                <Row className="d-flex justify-content-center">
                  <Col xxl={5} xl={5} lg={5} md={6} sm={12} xs={12} className="mb-4">
                    <Form.Group> <Form.Label> Confirm Password<span className="text-danger">*</span> </Form.Label> <Field type="password" name="confirmPassword" placeholder="new password" className={`form-control w-100 ${formik.touched.confirmPassword && formik.errors.confirmPassword ? "is-invalid" : ""}`} /> <ErrorMessage name="confirmPassword" component="div" className="text-danger mt-2" /> </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className="d-flex justify-content-center mb-4">
                    <Button variant="contained" color="primary" type="submit" startIcon={<FaKey style={{ fontSize: "13px" }} />}> Change </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </FormikProvider>
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
